import { PropsWithChildren } from "react";
import { Control, Controller, FieldValues, Path } from "react-hook-form";
import { RadioGroup } from "@headlessui/react";

interface StyledRadioGroupPropss<T extends FieldValues> extends PropsWithChildren {
  control: Control<T>;
  name: Path<T>;
  defaultValue?: string;
}

const StyledRadioGroup = <FieldsType extends FieldValues>({
  name,
  control,
  children,
  defaultValue,
}: StyledRadioGroupPropss<FieldsType>) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => {
        return (
          <RadioGroup value={field.value} onChange={field.onChange} defaultValue={defaultValue}>
            {children}
          </RadioGroup>
        );
      }}
    />
  );
};

export default StyledRadioGroup;
